import Constant from "../../../utils/constant";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router";
import Select, { SingleValue } from "react-select";
import { toast } from "react-toastify";
import {
  CaretDownSolidIcon,
  CaretUpSolidIcon,
  CopyIcon,
  DeleteIcon,
  EditIcon,
  FilterIcon,
  ResetIcon,
  EmailIcon,
  CleverIcon,
  ClasslinkIcon,
  GoogleIcon,
  CanvasIcon,
  DownloadIcon,
  ReactivateUserIcon,
  SkillIcon,
} from "../../../assets/icons";
import MultiStateButton from "../../shared/common/multiStateButton";
import Pagination from "../../shared/common/pagination";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import { getStateAll } from "../../../api/subject.service";
import roles from "../../../utils/roles.json";
import regions from "../../../utils/regions.json";
import { IReactSelect } from "../../../model/interface/keyValuePair";
import { IDistrictOption } from "../../../model/interface/districts";
import { formatDistrictOption } from "../../../utils/districtOptionHelper";
import {
  deleteUserById,
  fetchAccountDetail,
  getMiniCRMDistrictOptions,
  getMiniCRMUsers,
  exportMiniCRMUsers,
  ReActivateUser,
} from "../../../api/miniCrm.service";
import { CopyToClipboard } from "../../shared/common/CustomCopyToClipboard";
import { UserIcon, XIcon } from "@heroicons/react/outline";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import Loader from "../../shared/loader/loader";
import { Link } from "react-router";
import constant from "../../../utils/constant";
import UserEditPopup from "./Popup/userEditPopup";
import AllowedTo, { userPermissions } from "../../shared/common/rbac";
import Permissions from "../../../../src/utils/permissions";
import { createLoginLink } from "../../../api/user.service";
import { Configuration } from "../../../environment/setup";
import { downloadFile } from "../../../utils/reusedFunctions";
import { AxiosResponse } from "axios";

interface IUser {
  accountLoginName: string;
  districtId: number;
  districtName: string;
  email: string;
  expiryDate: string;
  externalRoster: string;
  firstName: string;
  isActive: boolean;
  isNWEADisabled: boolean;
  lastLogin: string | null;
  lastName: string;
  linkedStudentsCount: number;
  loginCount: number;
  nweaId: string | null;
  region: string | null;
  roleId: number;
  roleIds: number[] | null;
  roleName: string;
  schoolId: number;
  schoolName: string;
  startDate: string;
  stateId: number;
  stateName: string;
  studentId: number;
  totalRecords: number;
  updatedByUserId: number;
  userId: number;
  username: string;
}

const Users: React.FC = (props: any) => {
  const navigate = useNavigate();
  const canViewStudents = userPermissions().includes(
    Permissions.crm_students_view
  );
  const canLoginAs = userPermissions().includes(Permissions.crm_login_as_view);
  const permittedRoles = [
    Constant.UserRoleId.Student,
    Constant.UserRoleId.SchoolAdmin,
    Constant.UserRoleId.SchoolTeacher,
    Constant.UserRoleId.FreeTeacher,
    Constant.UserRoleId.PayTeacher,
    Constant.UserRoleId.District,
    Constant.UserRoleId.Guardian,
  ];
  const multiStateObjIsActive = [
    { label: "Active", value: true },
    { label: "Both", value: null, selected: true },
    { label: "Inactive", value: false },
  ];
  const multiStateGteLte = [
    { label: "Greater than", value: "Gte", selected: true },
    { label: "Less than", value: "Lte" },
  ];
  const externalRosterNames = ["Clever", "Classlink", "Google", "Canvas"];
  const externalRosterIcons = [
    <CleverIcon
      key={0}
      title="Clever"
      className="h-5 cursor-pointer hover:text-gray-500"
    />,
    <ClasslinkIcon
      key={1}
      title="Classlink"
      className="h-5 cursor-pointer hover:text-gray-500"
    />,
    <GoogleIcon
      key={2}
      title="Google"
      className="h-5 cursor-pointer hover:text-gray-500"
    />,
    <CanvasIcon
      key={3}
      title="Canvas"
      className="h-5 cursor-pointer hover:text-gray-500"
    />,
  ];
  const defaultSelect = { label: "", value: 0 };
  const [isActive, setIsActive] = useState<boolean | undefined>(true);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [sortCol, setSortCol] = useState<string>("stateName");
  const [sortByDesc, setSortByDesc] = useState<boolean>(false);
  const [states, setStates] = useState<Array<any>>([]);
  const [districts, setDistricts] = useState<Array<IDistrictOption>>([]);
  const [districtsLoading, setDistrictsLoading] = useState<boolean>(false);
  const [selectedState, setSelectedStates] =
    useState<IReactSelect>(defaultSelect);
  const [selectedDistrict, setSelectedDistrict] =
    useState<IReactSelect>(defaultSelect);
  const [selectedRole, setSelectedRole] = useState<IReactSelect>(defaultSelect);
  const [selectedRegion, setSelectedRegion] = useState<any>({
    label: "",
    value: "",
  });
  const [schoolName, setSchoolName] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [userId, setUserId] = useState<number | undefined>();
  const [studentId, setStudentId] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [users, setUsers] = useState<Array<IUser>>([]);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [openEditUserPopup, setOpenUserPopup] = useState<boolean>(false);
  const [deleteUser, setDeleteUser] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [editUser, setEditUser] = useState<IUser | undefined>(undefined);
  const [componentMounted, setComponentMounted] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [isFilterJustLoaded, setIsFilterJustLoaded] = useState(false);

  const MAX_EXPORT_COUNT = 5000;

  const [loginCountSearch, setLoginCountSearch] = useState<
    number | undefined
  >();
  const [loginCountGteLte, setLoginCountGteLte] = useState<string>("Gte");

  const saveFilterState = (isReset?) => {
    if (isReset) {
      localStorage.removeItem("miniCRM_usersFields");
    } else {
      const userFields = {
        selectedState: selectedState,
        selectedDistrict: selectedDistrict,
        schoolName: schoolName,
        selectedRole: selectedRole,
        firstName: firstName,
        lastName: lastName,
        userName: userName,
        userId: userId,
        studentId: studentId,
        email: email,
      };
      localStorage.setItem("miniCRM_usersFields", JSON.stringify(userFields));
    }
  };

  const loadFilterState = () => {
    const savedFields = localStorage.getItem("miniCRM_usersFields");
    if (savedFields) {
      const userFields = JSON.parse(savedFields);
      setSelectedStates(userFields.selectedState);
      setSelectedDistrict(userFields.selectedDistrict);
      setSchoolName(userFields.schoolName);
      setSelectedRole(userFields.selectedRole);
      setFirstName(userFields.firstName);
      setLastName(userFields.lastName);
      setUserName(userFields.userName);
      setUserId(userFields.userId);
      setStudentId(userFields.studentId);
      setEmail(userFields.email);
      setIsFilterJustLoaded(true);
      return userFields.selectedState?.value ?? 0;
    }
    return 0;
  };

  const loadDistricts = async (stateId = 0) => {
    setDistrictsLoading(true);
    try {
      const options = await getMiniCRMDistrictOptions(stateId);
      setDistricts(options);
      return options;
    } finally {
      setDistrictsLoading(false);
    }
  };

  useEffect(() => {
    loadDistricts(loadFilterState());
  }, []);

  useEffect(() => {
    if (isFilterJustLoaded) {
      getUsers(false);
      setIsFilterJustLoaded(false);
    }
  }, [isFilterJustLoaded]);

  useEffect(() => {
    if (componentMounted) getUsers();
    else setComponentMounted(true);
  }, [sortByDesc, sortCol]);

  useEffect(() => {
    if (isLoaded) {
      getUsers();
    }
  }, [pageNumber]);

  useEffect(() => {
    getStates();
    if (pageNumber === 1 && isLoaded) {
      getUsers();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  function emptyParams(params: any) {
    if (
      (params.stateId === undefined || params.stateId === 0) &&
      (params.districtId === undefined || params.districtId === 0) &&
      (params.schoolName === undefined || params.schoolName === "") &&
      (params.roleId === undefined || params.roleId === 0) &&
      (params.firstName === undefined || params.firstName === "") &&
      (params.lastName === undefined || params.lastName === "") &&
      (params.username === undefined || params.username === "") &&
      (params.userId === undefined || params.userId === 0) &&
      (params.email === undefined || params.email === "") &&
      (params.studentId === undefined || params.studentId === "")
    ) {
      return true;
    }
    return false;
  }

  const canLoginAsGuardian = (user: IUser) => {
    const isGuardian = user.roleId === Constant.UserRoleId.Guardian;
    if (!isGuardian) {
      return { allowed: true, reason: "" };
    }

    const linkedStudentsCount = user.linkedStudentsCount || 0;

    if (linkedStudentsCount < 1 || linkedStudentsCount > 30) {
      const reason =
        linkedStudentsCount === 0
          ? "Guardian must have at least 1 linked student"
          : "Guardian cannot have more than 30 linked students";
      return { allowed: false, reason };
    }

    return { allowed: true, reason: "" };
  };

  const loginAsUser = async (user: IUser) => {
    if (!user.isActive) {
      toast.error("User is INACTIVE");
      return;
    }

    if (user.roleId === Constant.UserRoleId.FreeTeacher) {
      toast.error("Login is not allowed for Free Teacher users");
      return;
    }

    const guardianCheck = canLoginAsGuardian(user);
    if (!guardianCheck.allowed) {
      toast.error(guardianCheck.reason);
      return;
    }

    const resp = await createLoginLink(user.userId, props?.profile?.userId);
    window.open(
      `${Configuration.PLApplicationURL}/?loginLinkId=${resp.data.loginLinkId}`,
      "_blank",
      "noreferrer"
    );
  };

  const exportUsers = async () => {
    const params = {
      stateId: selectedState?.value,
      region: selectedRegion?.value,
      districtId: selectedDistrict?.value,
      schoolName: schoolName,
      roleId: selectedRole?.value,
      firstName: firstName,
      lastName: lastName,
      username: userName,
      userId: userId,
      email: email,
      studentId: studentId,
      isActive: isActive,
      orderByColumn: "StateName",
      sortDir: "asc",
      pageSize: MAX_EXPORT_COUNT + 1,
      pageNumber: 1,
    };

    setLoading(true);
    let resp: AxiosResponse<any> | null = null;
    try {
      resp = await exportMiniCRMUsers(params);
      downloadFile(resp.data, "Users.xlsx");
    } catch (e: any) {
      if (e.isAxiosError) {
        switch (e.response?.status) {
          case 422:
            toast.error(
              `Too many results returned. The export feature is limited to ${MAX_EXPORT_COUNT} records. Please adjust your filters to keep the results within this limit.`
            );
            break;
          default:
            toast.error(
              e.response
                ? "An unexpected error was encountered while attempting to export results."
                : "Network error. Please check your connection and try again."
            );
            break;
        }
      }
    }
    setLoading(false);
  };

  const getUsers = async (isReset?) => {
    let params = {};
    if (isReset) {
      params = {
        stateId: 0,
        region: "",
        districtId: 0,
        schoolName: "",
        roleId: 0,
        firstName: "",
        lastName: "",
        username: "",
        userId: 0,
        email: "",
        studentId: 0,
        orderByColumn: sortCol,
        sortDir: sortByDesc ? "desc" : "asc",
        pageSize: 10,
        pageNumber: 1,
      };
    } else {
      params = {
        stateId: selectedState?.value,
        region: selectedRegion?.value,
        districtId: selectedDistrict?.value,
        schoolName: schoolName,
        roleId: selectedRole?.value,
        firstName: firstName,
        lastName: lastName,
        username: userName,
        userId: userId,
        email: email,
        studentId: studentId,
        isActive: isActive,
        orderByColumn: sortCol,
        sortDir: sortByDesc ? "desc" : "asc",
        loginCount: loginCountSearch,
        gteLte: loginCountGteLte,
        pageSize: pageSize,
        pageNumber: pageNumber,
      };
    }

    if (emptyParams(params)) {
      toast.error("You must select at least one filter");
      return;
    }
    setIsFilterReset(false);
    setLoading(true);
    saveFilterState(isReset);

    const resp = await getMiniCRMUsers(params);

    setLoading(false);

    if (resp && resp.data && resp.data.data) {
      setUsers(resp.data.data);
      setTotalPages(
        Math.ceil(resp.data.totalRecords / (isReset ? 10 : pageSize))
      );
      setTotalRecords(resp.data.totalRecords);
      setIsLoaded(true);
    }
  };

  const getStates = async () => {
    setLoading(true);
    const resp: any = await getStateAll(9999, 1);
    setLoading(false);
    if (resp && resp.data) {
      setStates(
        resp?.data?.data?.map((ds) => ({
          label: ds.name,
          value: ds.stateId,
        }))
      );
    }
  };

  const handleSortBy = (column: string) => {
    if (sortCol === column) {
      setSortByDesc(!sortByDesc);
    } else {
      setSortByDesc(false);
      setSortCol(column);
    }
  };

  const onStateChange = async (e) => {
    setLoading(true);
    setSelectedStates(e);

    const regionsData: any = regions.filter((ds) => ds.stateId === e.value);
    if (
      !(
        regionsData &&
        regionsData.length &&
        regionsData[0].regions &&
        regionsData[0].regions.length
      )
    ) {
      setSelectedRegion({ label: "", value: "" });
    }

    const options = await loadDistricts(e.value);
    setLoading(false);
    if (
      selectedDistrict?.value &&
      !options.some((ds) => ds.value === selectedDistrict.value)
    ) {
      setSelectedDistrict(defaultSelect);
    }
  };

  const resetClickHandler = () => {
    setIsFilterReset(true);
    setUsers([]);
    if (selectedState?.value) loadDistricts();
    setSelectedStates(defaultSelect);
    setSelectedRegion({ label: "", value: "" });
    setSelectedDistrict(defaultSelect);
    setSelectedRole(defaultSelect);
    setSchoolName("");
    setFirstName("");
    setLastName("");
    setUserName("");
    setUserId(undefined);
    setStudentId("");
    setEmail("");
    setResetDropdownFlag(!resetDropdownFlag);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
    const form: any = document.getElementById("users_form");
    if (form) form.reset();
  };

  const sendEmail = async (user) => {
    if (!user.email || user.email === "") {
      toast.error("Email is blank");
      return;
    }
    setLoading(true);
    fetchAccountDetail(user.accountLoginName, user.email)
      .then(() => {
        toast.success("Email sent successfully");
        setLoading(false);
      })
      .catch(() => {
        toast.error("Failed to send email");
        setLoading(false);
      });
  };

  const onDelete = async () => {
    setLoading(true);
    try {
      const resp = await deleteUserById(deleteUser?.userId);
      if (resp.data > 0) {
        toast.success("User deleted successfully");
        await getUsers();
      } else {
        toast.error("User delete failed");
      }
    } catch (e) {
      toast.error("User delete failed");
    } finally {
      setLoading(false);
      setDeleteUser(false);
    }
  };

  const onKeyPress = (e) => {
    if (e.charCode === 13) getUsers();
  };

  const handleSelectedDistrict = (option: SingleValue<IReactSelect> | null) => {
    if (option) {
      setSelectedDistrict(option);
    }
  };

  const handleSelectedRole = (option: SingleValue<IReactSelect> | null) => {
    if (option) {
      setSelectedRole(option);
    }
  };

  const handleReactivateUser = async (userId: number) => {
    setLoading(true);
    try {
      await ReActivateUser(userId);
      toast.success("User reactivated successfully");
      await getUsers();
    } catch (e) {
      toast.error("User reactivation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form id="users_form" className="p-3" onKeyPress={onKeyPress}>
      {loading && <Loader />}
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-3">
          <label className="text-sm text-gray-700">State</label>
          <Select
            className="mt-1 text-sm"
            options={states}
            value={selectedState}
            onChange={onStateChange}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: "#B3B3B3",
                primary: "#041E42",
              },
            })}
            styles={{
              control: (base, state) => ({
                ...base,
                background:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "#1A1C23"
                    : "white",
                borderColor:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "#6B7280"
                    : "#D1D5DB",
                borderWidth: "1px",
                "&:hover": {
                  borderColor:
                    state.isFocused &&
                    document.getElementsByClassName("dark")?.length > 0
                      ? "#6b7280"
                      : state.isFocused
                      ? "#4c5563"
                      : "",
                },
              }),
              singleValue: (base) => ({
                ...base,
                color:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "white"
                    : "#374051",
              }),
              input: (base) => ({
                ...base,
                color:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "white"
                    : "",
              }),
            }}
          />
        </div>

        <div className="col-span-3">
          <label className="text-sm text-gray-700">District</label>
          <Select
            className="mt-1 text-sm"
            value={selectedDistrict}
            options={districts}
            onChange={handleSelectedDistrict}
            isLoading={districtsLoading}
            formatOptionLabel={(option, { context }) =>
              formatDistrictOption(option, context, selectedState?.value)
            }
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: "#B3B3B3",
                primary: "#041E42",
              },
            })}
            styles={{
              control: (base, state) => ({
                ...base,
                background:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "#1A1C23"
                    : "white",
                borderColor:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "#6B7280"
                    : "#D1D5DB",
                borderWidth: "1px",
                "&:hover": {
                  borderColor:
                    state.isFocused &&
                    document.getElementsByClassName("dark")?.length > 0
                      ? "#6b7280"
                      : state.isFocused
                      ? "#4c5563"
                      : "",
                },
              }),
              singleValue: (base) => ({
                ...base,
                color:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "white"
                    : "#374051",
              }),
              input: (base) => ({
                ...base,
                color:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "white"
                    : "",
              }),
            }}
          />
        </div>

        <div className="col-span-3">
          <label className="text-sm text-gray-700">School</label>
          <input
            name="school"
            type="text"
            autoComplete="off"
            value={schoolName}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
            onChange={(e) => setSchoolName(e.target.value)}
          />
        </div>

        <div className="col-span-3">
          <label className="text-sm text-gray-700">Role</label>
          <Select
            className="mt-1 text-sm"
            value={selectedRole}
            options={
              canViewStudents ? roles : roles.filter((r) => r.value !== 9)
            }
            onChange={handleSelectedRole}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: "#B3B3B3",
                primary: "#041E42",
              },
            })}
            styles={{
              control: (base, state) => ({
                ...base,
                background:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "#1A1C23"
                    : "white",
                borderColor:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "#6B7280"
                    : "#D1D5DB",
                borderWidth: "1px",
                "&:hover": {
                  borderColor:
                    state.isFocused &&
                    document.getElementsByClassName("dark")?.length > 0
                      ? "#6b7280"
                      : state.isFocused
                      ? "#4c5563"
                      : "",
                },
              }),
              singleValue: (base) => ({
                ...base,
                color:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "white"
                    : "#374051",
              }),
              input: (base) => ({
                ...base,
                color:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "white"
                    : "",
              }),
            }}
          />
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 mt-5">
        <div className="col-span-3">
          <label className="text-sm text-gray-700">First Name</label>
          <input
            name="firstName"
            type="text"
            autoComplete="off"
            value={firstName}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>

        <div className="col-span-3">
          <label className="text-sm text-gray-700">Last Name</label>
          <input
            name="lastName"
            type="text"
            autoComplete="off"
            value={lastName}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>

        <div className="col-span-3">
          <label className="text-sm text-gray-700">Username</label>
          <input
            name="userName"
            type="text"
            autoComplete="off"
            value={userName}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
            onChange={(e) => setUserName(e.target.value)}
          />
        </div>
        <div className="col-span-3">
          <label className="text-sm text-gray-700">User Id</label>
          <input
            name="userId"
            type="text"
            autoComplete="off"
            value={userId ?? ""}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
            onChange={(e) => setUserId(Number(e.target.value))}
          />
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 mt-5">
        <div className="col-span-3">
          <label className="text-sm text-gray-700">Student ID</label>
          <input
            name="studentId"
            type="text"
            autoComplete="off"
            value={studentId}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
            onChange={(e) => setStudentId(e.target.value)}
          />
        </div>

        <div className="col-span-3">
          <label className="text-sm text-gray-700">Email</label>
          <input
            name="email"
            type="text"
            autoComplete="off"
            value={email}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="col-span-3 flex">
          <label className="text-sm text-gray-700 w-1/3 mr-1">
            Login Count
            <input
              name="loginCount"
              type="number"
              autoComplete="off"
              value={loginCountSearch}
              className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
              onChange={(e) =>
                setLoginCountSearch(
                  e.target.value !== "" ? parseInt(e.target.value) : undefined
                )
              }
            />
          </label>
          <div className="flex items-center w-2/3 mt-6">
            <MultiStateButton
              labels={multiStateGteLte}
              onSelect={(e) => setLoginCountGteLte(e.value)}
              onReset={resetDropdownFlag}
            />
          </div>
        </div>

        <div className="col-span-3 flex flex-wrap">
          <div className="flex items-center mt-6">
            <MultiStateButton
              labels={multiStateObjIsActive}
              onSelect={(e) => setIsActive(e.value)}
              onReset={resetDropdownFlag}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-start mb-5">
        <button
          autoFocus
          type="button"
          onClick={() => getUsers()}
          className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
        >
          <FilterIcon className="w-3 h-3" />
          <span>Filter</span>
        </button>
        <button
          autoFocus
          type="button"
          onClick={() => exportUsers()}
          className="mt-4 inline-flex ml-3 items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
        >
          <DownloadIcon className="w-3 h-3" />
          <span>Export</span>
        </button>
        <button
          type="button"
          onClick={resetClickHandler}
          className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
        >
          <ResetIcon className="w-3 h-3" />
          <span>Reset Filter</span>
        </button>
      </div>

      <div className="mt-4 border-t pt-6">
        <div className="flex flex-col mt-1">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-primary-color">
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                      >
                        User Id
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("stateName")}
                      >
                        <span className="flex">
                          State
                          {sortCol === "stateName" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("districtName")}
                      >
                        <span className="flex">
                          District
                          {sortCol === "districtName" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>

                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("schoolName")}
                      >
                        <span className="flex">
                          School
                          {sortCol === "schoolName" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>

                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("firstName")}
                      >
                        <span className="flex">
                          First Name
                          {sortCol === "firstName" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>

                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("lastName")}
                      >
                        <span className="flex">
                          Last Name
                          {sortCol === "lastName" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("accountLoginName")}
                      >
                        <span className="flex">
                          Account Login Name
                          {sortCol === "accountLoginName" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("userName")}
                      >
                        <span className="flex">
                          Username
                          {sortCol === "userName" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>

                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("email")}
                      >
                        <span className="flex">
                          Email
                          {sortCol === "email" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>

                      <th></th>

                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                      >
                        <span className="flex">Account Creation Method</span>
                      </th>

                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("roleName")}
                      >
                        <span className="flex">
                          Role
                          {sortCol === "roleName" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>

                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("loginCount")}
                      >
                        <span className="flex">
                          LoginCount
                          {sortCol === "loginCount" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>

                      <th
                        scope="col"
                        className="min-w-fit px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("lastLogin")}
                      >
                        <span className="flex">
                          Last Login
                          {sortCol === "lastLogin" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>

                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider cursor-pointer"
                        onClick={() => handleSortBy("expiryDate")}
                      >
                        <span className="flex">
                          Expiry Date
                          {sortCol === "expiryDate" && (
                            <span>
                              {!sortByDesc ? (
                                <CaretUpSolidIcon className="w-5 h-5"></CaretUpSolidIcon>
                              ) : (
                                <CaretDownSolidIcon className="w-5 h-5"></CaretDownSolidIcon>
                              )}
                            </span>
                          )}
                        </span>
                      </th>

                      {canLoginAs && (
                        <th
                          scope="col"
                          className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                        >
                          Login as User
                        </th>
                      )}

                      <th
                        scope="col"
                        className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {users?.map((user, i) => (
                      <tr
                        key={i}
                        className={`align-top ${
                          i % 2 === 0 ? "bg-white " : "bg-gray-100"
                        }`}
                      >
                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          {user.userId}
                        </td>
                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          {user.stateName}
                        </td>
                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          <Link
                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                            to={constant.DISTRICTDETAIL.replace(
                              ":id",
                              user.districtId.toString()
                            )}
                          >
                            {user.districtName}
                          </Link>
                        </td>
                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          <Link
                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                            to={constant.SCHOOLDETAIL.replace(
                              ":id",
                              user.schoolId.toString()
                            )}
                          >
                            {user.schoolName}
                          </Link>
                        </td>
                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          {user.firstName}
                        </td>

                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          {user.lastName}
                        </td>
                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          <div className="flex">
                            {user.accountLoginName}
                            <CopyToClipboard text={user.accountLoginName}>
                              <CopyIcon
                                title="Copy account login"
                                onClick={() => {
                                  toast.success(
                                    "Account login name copied to clipboard"
                                  );
                                }}
                              />
                            </CopyToClipboard>
                          </div>
                        </td>
                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          <div className="flex">
                            {user.username}
                            <CopyToClipboard text={user.username}>
                              <CopyIcon
                                title="Copy username"
                                onClick={() => {
                                  toast.success("Username copied to clipboard");
                                }}
                              />
                            </CopyToClipboard>
                          </div>
                        </td>

                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          {user.email}
                        </td>

                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          <EmailIcon
                            title="Send Login by Email"
                            onClick={() => sendEmail(user)}
                            className="h-5 cursor-pointer hover:text-gray-500"
                          />
                        </td>

                        <td className="px-3 py-2 text-sm text-left font-normal relative">
                          {externalRosterNames.includes(user.externalRoster) &&
                            externalRosterIcons[
                              externalRosterNames.indexOf(user.externalRoster)
                            ]}
                          {!externalRosterNames.includes(user.externalRoster) &&
                            user.externalRoster}
                        </td>

                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          {user.roleName}
                        </td>

                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          {user.loginCount ?? 0}
                        </td>

                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          {user.lastLogin && (
                            <>
                              {moment(user.lastLogin).format(
                                "MM-DD-YYYY HH:mm:ss"
                              )}
                            </>
                          )}
                        </td>

                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          {moment(user.expiryDate).format("MM-DD-YYYY")}
                        </td>

                        {canLoginAs && (
                          <td className=" px-3 py-2  text-sm text-left font-normal relative">
                            {permittedRoles.includes(user.roleId) &&
                              (() => {
                                const guardianCheck = canLoginAsGuardian(user);
                                const isDisabled =
                                  !guardianCheck.allowed ||
                                  user.roleId ===
                                    Constant.UserRoleId.FreeTeacher;

                                const disabledReason =
                                  user.roleId ===
                                  Constant.UserRoleId.FreeTeacher
                                    ? "Login is not allowed for Free Teacher users"
                                    : guardianCheck.reason;

                                return (
                                  <div className="relative inline-block">
                                    <button
                                      type="button"
                                      onClick={() => loginAsUser(user)}
                                      disabled={isDisabled}
                                      title={isDisabled ? disabledReason : ""}
                                      className={`mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg border gap-2 focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                                        isDisabled
                                          ? "text-gray-400 border-gray-200 bg-gray-100 cursor-not-allowed"
                                          : "text-gray-700 text-primary-color border-gray-300 bg-white hover:text-gray-500 focus:ring-primary-color"
                                      }`}
                                    >
                                      <UserIcon className="w-3 h-3" />
                                      <span>Login</span>
                                    </button>
                                  </div>
                                );
                              })()}
                          </td>
                        )}
                        <td className=" px-3 py-2  text-sm text-left font-normal relative">
                          <div className="flex justify-start items-center">
                            {user.isActive ? (
                              <AllowedTo perform={Permissions.user_delete}>
                                <DeleteIcon
                                  title="Delete user"
                                  onClick={() =>
                                    setDeleteUser({
                                      open: true,
                                      userId: user.userId,
                                      userName: user.username,
                                    })
                                  }
                                  className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                />
                              </AllowedTo>
                            ) : (
                              <AllowedTo perform={Permissions.user_delete}>
                                <ReactivateUserIcon
                                  title="Reactivate user"
                                  onClick={() =>
                                    handleReactivateUser(user.userId)
                                  }
                                  className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                />
                              </AllowedTo>
                            )}
                            <AllowedTo perform={Permissions.user_modify}>
                              <EditIcon
                                title="Edit user"
                                onClick={() => {
                                  setEditUser(user);
                                  setOpenUserPopup(true);
                                }}
                                className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                              />
                            </AllowedTo>
                            {user.roleId === Constant.UserRoleId.District && (
                              <AllowedTo perform={Permissions.crm_content_view}>
                                <SkillIcon
                                  title="Edit content"
                                  onClick={() =>
                                    navigate(
                                      `/crm/users/${user.userId}/content`
                                    )
                                  }
                                  className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                />
                              </AllowedTo>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {users.length === 0 && <p className="p-2">No Records Found</p>}
              </div>
            </div>
          </div>
          {!isFilterReset && users.length > 0 && (
            <div className="flex justify-between items-center">
              <Pagination
                pages={totalPages}
                setPageNumber={setPageNumber}
                ref={paginationRef}
              />
              <span>
                <span className="text-sm pr-4 ml-auto text-left-700">
                  Showing {pageNumber} to{" "}
                  {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                  {totalRecords} results{" "}
                </span>

                <SelectPageSize
                  setPageSize={setPageSize}
                  type={"second"}
                  ref={pageSizeRef}
                />
              </span>
            </div>
          )}
        </div>
      </div>

      {openEditUserPopup && (
        <UserEditPopup
          onClose={() => setOpenUserPopup(false)}
          user={editUser}
        />
      )}

      {deleteUser?.open && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            <div className="rounded-lg inline-block align-bottom bg-white px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 h-auto">
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button
                  onClick={() =>
                    setDeleteUser({ open: false, userName: "", userId: 0 })
                  }
                  type="button"
                  className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-text-primary"
                >
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>

              <div className="flex justify-center font-semibold">
                <h2 className="text-gray-700  text-2xl">Are you sure?</h2>
              </div>

              <div className="mt-2 flex justify-center">
                <h2 className="text-gray-700 text-lg">
                  You want to delete{" "}
                  <span className="font-semibold text-black text-xl">
                    {deleteUser.userName}
                  </span>{" "}
                  user
                </h2>
              </div>

              <div className="flex justify-end pt-4">
                <button
                  type="button"
                  onClick={() => onDelete()}
                  className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                >
                  <span>Delete</span>
                </button>

                <button
                  type="button"
                  onClick={() =>
                    setDeleteUser({ open: false, userId: 0, userName: "" })
                  }
                  className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <span>Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </form>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(Users);
